import React from 'react';
import { X } from 'lucide-react';

interface NotificationsPopupProps {
  onClose: () => void;
}

const NotificationsPopup: React.FC<NotificationsPopupProps> = ({ onClose }) => {
  return (
    <div className="fixed top-0 right-0 h-full w-80 bg-white shadow-lg z-50 flex flex-col">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <h2 className="text-xl font-bold text-gray-800">Notificaciones</h2>
        <button 
          onClick={onClose} 
          className="p-1 rounded-full hover:bg-gray-100 transition-colors"
        >
          <X size={20} className="text-gray-600" />
        </button>
      </div>

      {/* Notification List */}
      <div className="flex-grow p-4 space-y-4">
        {/* Example Notification Item */}
        <div className="flex items-start space-x-3">
          {/* Orange speech bubble icon with three dots */}
          <div className="flex-shrink-0 w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
            <div className="flex space-x-1">
              <div className="w-1 h-1 bg-white rounded-full"></div>
              <div className="w-1 h-1 bg-white rounded-full"></div>
              <div className="w-1 h-1 bg-white rounded-full"></div>
            </div>
          </div>
          <p className="text-gray-700 text-sm font-medium">Entrenamiento en SAP Signavio</p>
        </div>
        
        {/* Empty state for additional notifications */}
        <div className="text-center text-gray-500 text-sm py-8">
          No hay más notificaciones
        </div>
      </div>
    </div>
  );
};

export default NotificationsPopup;